module.exports = __webpack_public_path__ + "img/value_cover_013.db9b3eff.jpg";